import React, {useEffect, useRef, useState} from 'react';
import './App.css';
import Main from "./components/Main";
import {useSelector} from "react-redux";
import {mainSelector} from "./store/slices/main.slice";
import {persistor} from "./store";
import MenuModalRoot from "./components/modals/MenuModalRoot";
import "./i18n";
import {useTranslation} from "react-i18next";
import {changeLanguageSafe} from "./i18nSwitch";
import ARLanding from "./components/ARLanding";
import MobileAR from "./components/MobileAR";

function App() {
    const audioRef: any = useRef();
    const { sound } = useSelector(mainSelector);
    const { i18n } = useTranslation();

    useEffect(() => {
        changeLanguageSafe(i18n.language);
    }, []);

    // Audio
    const startAudio = () => {
        audioRef.current!.play();
    };

    const pauseAudio = () => {
        audioRef.current!.pause();
    };

    useEffect(() => {
        if(audioRef && audioRef.current) {
            if(sound) {
                startAudio()
            } else {
                pauseAudio()
            }
        }
    }, [sound, audioRef, audioRef.current]);

    useEffect(() => {
        const handleBeforeUnload = () => {
            persistor.purge();  // Questo cancella i dati persistenti
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    return (
        <>
            <audio controls ref={audioRef} style={{opacity: 0, position: 'absolute'}}>
                <source src="./audio/VT_open_space.mp3" type="audio/mp3"/>
                Your browser does not support the audio element.
            </audio>
            <MenuModalRoot />
            {window.location.href.includes('/ar') ? <ARLanding/> : <Main/>}
        </>
    );
}

export default App;